const networkIcons = {
  1: "https://cdn.worldvectorlogo.com/logos/ethereum-eth.svg", // Ethereum Mainnet
  3: "https://cdn.worldvectorlogo.com/logos/ethereum-eth.svg", // Ropsten Testnet
  4: "https://cdn.worldvectorlogo.com/logos/ethereum-eth.svg", // Rinkeby Testnet
  5: "https://cdn.worldvectorlogo.com/logos/ethereum-eth.svg", // Goerli Testnet
  42: "https://cdn.worldvectorlogo.com/logos/ethereum-eth.svg", // Kovan Testnet
  56: "https://cryptologos.cc/logos/bnb-bnb-logo.svg", // Binance Smart Chain (BSC)
  137: "https://cryptologos.cc/logos/polygon-matic-logo.svg", // Polygon (Matic)
  250: "https://cryptologos.cc/logos/fantom-ftm-logo.svg", // Fantom
  42161: "https://cryptologos.cc/logos/arbitrum-arb-logo.svg", // Arbitrum One
  10: "https://cryptologos.cc/logos/optimism-optimism-logo.svg", // Optimism
  1666600000: "https://cryptologos.cc/logos/harmony-one-logo.svg", // Harmony
  1284: "https://cryptologos.cc/logos/moonbeam-glmr-logo.svg", // Moonbeam
  100: "https://cryptologos.cc/logos/xdai-xdai-logo.svg", // xDai
  42220: "https://cryptologos.cc/logos/celo-celo-logo.svg", // Celo
  2222: "https://cryptologos.cc/logos/kava-kava-logo.svg", // Kava
  40: "https://cryptologos.cc/logos/telos-tlos-logo.svg", // Telos
  128: "https://cryptologos.cc/logos/heco-heco-logo.svg", // HECO
  42262: "https://cryptologos.cc/logos/oasis-network-rose-logo.svg", // Oasis
  4689: "https://cryptologos.cc/logos/iotex-iotx-logo.svg", // IoTeX
  1219: "https://cryptologos.cc/logos/firo-firo-logo.svg", // Firo
  57: "https://cryptologos.cc/logos/syscoin-sys-logo.svg", // Syscoin
  8888: "https://cryptologos.cc/logos/wanchain-wan-logo.svg", // Wanchain
  333: "https://cryptologos.cc/logos/zilliqa-zil-logo.svg", // Zilliqa
  1313161554: "https://cryptologos.cc/logos/near-protocol-near-logo.svg", // Near Protocol
  101: "https://cryptologos.cc/logos/solana-sol-logo.svg", // Solana
  2: "https://cryptologos.cc/logos/kusama-ksm-logo.svg", // Kusama
  0: "https://cryptologos.cc/logos/polkadot-dot-logo.svg", // Polkadot
  1815: "https://cryptologos.cc/logos/cardano-ada-logo.svg", // Cardano
  719: "https://cryptologos.cc/logos/binance-coin-bnb-logo.svg", // Binance Chain
  66: "https://cryptologos.cc/logos/okex-coin-okb-logo.svg", // OKExChain
  9318: "https://cryptologos.cc/logos/thorchain-rune-logo.svg", // Thorchain
  888: "https://cryptologos.cc/logos/vechain-vet-logo.svg", // VeChain
  51: "https://cryptologos.cc/logos/multiversx-elrond-logo.svg", // Elrond (MultiversX)
  1285: "https://cryptologos.cc/logos/moonriver-movr-logo.svg", // Moonriver
  2112: "https://cryptologos.cc/logos/aurora-aurora-logo.svg", // Aurora
  43113: "https://cryptologos.cc/logos/avalanche-avax-logo.svg", // Avalanche Fuji C-Chain (Testnet)
  97: "https://cryptologos.cc/logos/bnb-bnb-logo.svg", // Binance Smart Chain Testnet (BSC Testnet)
  4224: "https://cryptologos.cc/logos/celo-celo-logo.svg", // Celo Testnet
  8453: "https://cryptologos.cc/logos/polygon-matic-logo.svg", // Polygon Mumbai Testnet
  80001: "https://cryptologos.cc/logos/polygon-matic-logo.svg", // Polygon Mumbai Testnet
  1234: "https://cryptologos.cc/logos/avalanche-avax-logo.svg", // Avalanche Fuji Testnet
  536: "https://cdn.worldvectorlogo.com/logos/ethereum-eth.svg", // Ethereum Classic
  819: "https://cryptologos.cc/logos/hardcap-logo.svg", // Hardcap Network
  10000: "https://cryptologos.cc/logos/zk-sync-zks-logo.svg", // zkSync
  42: "https://cdn.worldvectorlogo.com/logos/ethereum-eth.svg", // Ethereum Kovan Testnet
  1636: "https://cryptologos.cc/logos/elrond-elrond-logo.svg", // Elrond Mainnet
  8880: "https://cryptologos.cc/logos/optimism-optimism-logo.svg", // Optimism Testnet
  12347: "https://cryptologos.cc/logos/thorchain-rune-logo.svg", // Thorchain Testnet
  1221: "https://cryptologos.cc/logos/ronin-ronin-logo.svg", // Ronin
  1088: "https://cryptologos.cc/logos/sora-sora-logo.svg", // Sora
  1071: "https://cryptologos.cc/logos/velas-velas-logo.svg", // Velas
  973: "https://cryptologos.cc/logos/avalanche-avax-logo.svg", // Avalanche C-Chain
  123: "https://cryptologos.cc/logos/solana-sol-logo.svg", // Solana Testnet
  1235: "https://cryptologos.cc/logos/moonbeam-glmr-logo.svg", // Moonbeam Testnet
  210: "https://cryptologos.cc/logos/hardcap-logo.svg", // Hardcap Mainnet
  9000: "https://cryptologos.cc/logos/zk-sync-zks-logo.svg", // zkSync Mainnet
  302: "https://cryptologos.cc/logos/defichain-defi-logo.svg", // DeFiChain
  8039: "https://cryptologos.cc/logos/sora-sora-logo.svg", // Sora Testnet
  7777: "https://cdn.worldvectorlogo.com/logos/ethereum-eth.svg", // Ethereum Testnet
  777: "https://cryptologos.cc/logos/solana-sol-logo.svg", // Solana Devnet
  47: "https://cryptologos.cc/logos/evmos-evmos-logo.svg", // Evmos
};

export default function getNetworkIcon(networkId) {
  return networkIcons[networkId] || "https://cryptologos.cc/logos/ethereum-eth-logo.svg"; // 默认图标URL
}
